module.exports = __webpack_public_path__ + "static/media/Rapper.fcf06ada.jpg";